import { Dimensions } from "react-native";

const { width, height } = Dimensions.get("window");

const ScreenWidth = height > width ? width : height;
const ScreenHeight = height > width ? height : width;

export { ScreenHeight, ScreenWidth };
